import React, { useEffect, useState, useRef, useContext } from 'react';
import { CommonModal, CustomPagination } from 'components';
import StorageService from "utils/StorageServices/StorageServices";
import toast from 'react-hot-toast';
import { Link, useNavigate } from 'react-router-dom';
import { AddEditMarketDriver } from 'modals';
import { deleteMarketDriverData, getMarketDriverListData } from '_services/accountsServices/marketDriverServices';
import BootstrapTable from 'components/BootstrapTable';
import { BsThreeDotsVertical } from "react-icons/bs";
import { AiOutlineEye } from "react-icons/ai";
import { FiEdit } from "react-icons/fi";
import { FaRegTrashCan } from "react-icons/fa6";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import { changeDriverStatusData } from '_services/accountsServices/ownDriverServices';
import LoadingBar from 'react-top-loading-bar';
import { UserContext } from 'context';
import { getDriverDropdownListData } from '_services/dropdownServices/dropdownService';
import useDocumentTitle from 'hooks/useDocumentTitle';
import { constant } from 'constants/constant';

const MarketDriver = ({ showOffcanvas, toggleOffcanvas, listSearch }) => {
  useDocumentTitle("Market Driver | T360");
  const loadingBarRef = useRef(null);
  const { masterData, cities, states, mastersChild, setMasterDetailsList } = useContext(UserContext);
  const masterChildDriver = mastersChild?.find((i) => i?.label === "Driver");
  const [marketDriverList, setMarketDriverList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isDelete, setIsDelete] = useState(false);

  const navigate = useNavigate();

  const itemsPerPage = 25;
  const [totalItems, setTotalItems] = useState(0);
  const [filter, setFilter] = useState({
    limit: 25,
    offset: 1,
    search: '',
    status: 1,
    driver_type: 2
  });
  const [checkboxStates, setCheckboxStates] = useState({});

  const getDataMarketDriverList = async () => {
    try {
      setLoading(true);
      if (loadingBarRef.current) {
        loadingBarRef.current.continuousStart(); // Start the loading bar
      }
      let object = {
        ...filter,
        ...listSearch,
        company_id: StorageService.getCompanyId(),
        firm_id: StorageService.getFirmId(),
      }
      // const res = await getDriverDropdownListData(object);
      const res = await getMarketDriverListData(object);
      if (res?.responseCode == 200) {
        setMarketDriverList(res?.data?.driver_list);
        setTotalItems(res?.data?.total_record);
      }
    } catch (error) {
      // throw error;
    } finally {
      setLoading(false);
      if (loadingBarRef.current) {
        loadingBarRef.current.complete(); // Complete the loading bar
      }
    }
  }

  useEffect(() => {
    getDataMarketDriverList();
  }, [listSearch, filter, showOffcanvas])

  useEffect(() => {
    setMasterDetailsList({})
  }, [])

  const deleteHandler = (item) => {
    setIsDelete(item)
  }

  const submitDeleteMarketDriver = async () => {
    setLoading(true);
    try {
      let object = {
        company_id: StorageService.getCompanyId(),
        driver_id: isDelete?._id,
      }
      const res = await deleteMarketDriverData(object);
      if (res?.responseCode == 200) {
        toast.success(`${res?.responseMessage}`);
        getDataMarketDriverList();
        setLoading(false);
        setIsDelete(false);
      } else {
        toast.success('Error !! ');
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      // throw error;
    }
  }

  let propsObject = {
    isOpen: isDelete,
    closeModal: setIsDelete,
    modalTitle: "Confirmation",
    submitTitle: "Confirm",
    cancleTitle: "Close",
    onSubmit: submitDeleteMarketDriver,
    isLoadding: loading,
  }

  const columns = [
    // { header: "", accessor: "serial" },
    { header: "Driver Name", accessor: "driver_name" },
    { header: "Firm", accessor: "firm_id" },
    { header: "Contact No.", accessor: "contact_nunber" },
    { header: "Licence No.", accessor: "licence_number" },
    { header: "Truck Associated", accessor: "truck_associated" },
    { header: "Status", accessor: "status" },
    { header: "Action", accessor: "action" },

  ];

  useEffect(() => {
    if (marketDriverList && marketDriverList.length > 0) {
      const initialStates = marketDriverList.reduce((acc, item) => {
        acc[item._id] = Boolean(item?.active);
        return acc;
      }, {});
      setCheckboxStates(initialStates);
    }
  }, [marketDriverList]);

  const handleCheckboxChange = (id) => {
    const newStatus = !checkboxStates[id];

    setCheckboxStates(prevStates => ({ ...prevStates, [id]: newStatus }));

    const object = {
      company_id: StorageService.getCompanyId(),
      driver_id: id,
      active: Number(newStatus)
    };
    statusChangeofOwnDriver(object);
  };

  const statusChangeofOwnDriver = async (obj) => {
    try {
      if (obj) {
        const res = await changeDriverStatusData(obj);
        if (res?.responseCode === 200) {
          toast.success(`${res?.responseMessage}`);
        } else {
          toast.error('Error !!');
          await getDataMarketDriverList();
        }
      }
    } catch (error) {
      toast.error(error.message);
      await getDataMarketDriverList();
    }
  };

  const editHandler = (data) => {
    toggleOffcanvas(data);
  };

  const handleClick = (event) => {
    event.stopPropagation();
  };

  const onRowClick = (e, item) => {
    navigate(`details/${item?._id}?type=${constant.m_type.market_driver}&tab=${1}&search=${filter?.search}&offset=${+filter?.offset}&total_record=${totalItems}&name=${item?.name}&driver_type=${2}`)
    setMasterDetailsList((s) => ({ ...s, list: marketDriverList, details: item }))
  }

  const RowListData = (data) => {
    return data?.map((item, i) => ({
      ...item,
      serial: <>
        <div className="signDropdown">
          <button className="dropbtn11">
            <BsThreeDotsVertical />
          </button>
          <div className="dropdownContent">
            {masterChildDriver?.view === 1 && <Link to={`/account/driver/details/${item?._id}`} className='_avPointer'
              style={{ textDecoration: 'none' }}
            >
              <span className='_samAnchor'>
                <span className='viewIcon_avt'>
                  <AiOutlineEye />
                </span>View
              </span>
            </Link>}

            {masterChildDriver?.edit === 1 && <div
              onClick={(e) => editHandler(item)}
              className='_avPointer'
            >
              <span className='_samAnchor'>
                <span className='editIcon_avt'>
                  <FiEdit />
                </span>
                Edit
              </span>
            </div>}

            {/* {masterChildDriver?.delete === 1 && <div
              onClick={(e) => deleteHandler(item)}
              className='_avPointer'
            >
              <span className='_samAnchor'>
                <span className='deleteIcon_avt'>
                  <FaRegTrashCan color='red' />
                </span>
                Delete
              </span>
            </div>} */}
          </div>
        </div>

      </>,
      driver_name:
        <Link
          to={`details/${item?._id}?type=${constant.m_type.market_driver}&tab=${1}&search=${filter?.search}&offset=${+filter?.offset}&total_record=${totalItems}&name=${item?.name}&driver_type=${2}`}
          style={{ textDecoration: 'none' }}
          onClick={(e) => { handleClick(e); setMasterDetailsList((s) => ({ ...s, list: marketDriverList, details: item })) }}
        >
          {item?.name ? item?.name : '-'}
        </Link>,
      firm_id: <React.Fragment>
        {item?.firm_id?.firm ? item?.firm_id?.firm : '-'}
      </React.Fragment>,
      contact_nunber:
        <React.Fragment>
          {item?.contact_no ? item?.contact_no : '-'}
        </React.Fragment>,
      licence_number:
        <React.Fragment>
          {item?.licence_number ? item?.licence_number : '-'}
        </React.Fragment>,
      truck_associated:
        <React.Fragment>
          -
        </React.Fragment>,
      status: (
        <div className="_anvSwitcherNew form-check form-switch" style={{ width: "125px" }} onClick={(e) => handleClick(e)}>
          <input
            className="form-check-input"
            type="checkbox"
            name="actStatus"
            id={`actStatus-${item._id}`}
            autoComplete="off"
            checked={checkboxStates[item._id]}
            onChange={() => handleCheckboxChange(item._id)}
          />
          <span className={checkboxStates[item._id] ? "active_label_masters_status" : "disabled_label_masters_status"}>
            {checkboxStates[item._id] ? "Active" : "Disabled"}
          </span>
        </div>
      ),
      action: (
        <div
          className="_anvSwitcherNew form-check form-switch"
          style={{ width: "100px" }}
        >
          {masterChildDriver?.view === 1 &&
            <Link
              to={`details/${item?._id}?type=${constant.m_type.market_driver}&tab=${1}&search=${filter?.search}&offset=${+filter?.offset}&total_record=${totalItems}&name=${item?.name}&driver_type=${2}`}
              className='_avPointer'
              style={{ textDecoration: 'none' }}
              onClick={(e) => { handleClick(e); setMasterDetailsList((s) => ({ ...s, list: marketDriverList, details: item })) }}
            >
              <span className='_samAnchor'>
                <span className='viewIcon_avt'>
                  <AiOutlineEye color='green' />
                </span>
              </span>
            </Link>}

          {masterChildDriver?.edit === 1 && <div
            onClick={(e) => { handleClick(e); editHandler(item) }}
            className='_avPointer'
          >
            <span className='_samAnchor'>
              <span className='editIcon_avt'>
                <FiEdit color='blue' />
              </span>

            </span>
          </div>}

          {/* {masterChildDriver?.delete === 1 && <div
              onClick={(e) => deleteHandler(item)}
              className='_avPointer'
            >
              <span className='_samAnchor'>
                <span className='deleteIcon_avt'>
                  <FaRegTrashCan color='red' />
                </span>
               
              </span>
            </div>} */}
        </div>
      ),
    }));
  };

  const handlePageChange = (page) => {
    setFilter((s) => ({ ...s, offset: page }))
  };

  return (
    <div>
      <LoadingBar
        color="#ffa800"
        ref={loadingBarRef}
        height={4}
        shadow={true}
        loaderSpeed={1000}
      />
      <div className='_tabWith_topTab'>
        <BootstrapTable
          columns={columns}
          data={RowListData(marketDriverList?.length > 0 ? marketDriverList : [])}
          isLoading={loading}
          onRowClick={(e, row) => {
            if (e.target.closest(".no-row-click")) return; // ignore protected cells
            onRowClick(e, row);
          }}
        />

        {marketDriverList?.length > 0 ? <div className='paginationFt_avt'>
          <CustomPagination
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            currentPage={filter.offset}
            onPageChange={handlePageChange}
          />
        </div> : <></>}
      </div>

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvas ? 'show' : ''}`}
        tabIndex={-1}
        style={{ visibility: showOffcanvas ? 'visible' : 'hidden' }}
      >
        {showOffcanvas &&
          <AddEditMarketDriver isOpen={showOffcanvas} onClose={toggleOffcanvas} />
        }
      </div>

      <div className={showOffcanvas ? 'offBack_drop' : ''}></div>

      {
        isDelete?._id && (
          <CommonModal {...propsObject}>
            <p className='p-3'> Are you sure you want to delete {isDelete?.name} ?</p>
          </CommonModal>
        )
      }
    </div>
  )
}

export default MarketDriver;
